import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Person from '../forecast-app/shared/components/person/person';
import {profilePicSrc} from '../constants';

class FilterPerson extends Component {
	render() {
		const {person} = this.props;
		return (
			<div className="filter-person" style={this.props.negativeMargin ? {margin: '-8px, 0'} : {}}>
				{person.id ? (
					<Person
						name={`${person.firstName} ${person.lastName}`}
						showName={true}
						showRole={true}
						role={person.role ? person.role.name : ''}
						imageSize={'new-ui-dropdown'}
						imageSrc={person.profilePictureId ? profilePicSrc(person.profilePictureId) : null}
						ownerBorderColor={this.props.borderColor}
						personSelected={this.props.selected}
						cy={`${this.props.cy || ''}-person-filter`}
					/>
				) : (
					<div className={`no-person${this.props.selected ? ' person-selected' : ''}`}>{person.firstName}</div>
				)}
			</div>
		);
	}
}

FilterPerson.propTypes = {
	person: PropTypes.object.isRequired,
	negativeMargin: PropTypes.bool,
	borderColor: PropTypes.string,
	selected: PropTypes.bool,
	cy: PropTypes.string,
};

export default FilterPerson;
